// extracted by mini-css-extract-plugin
module.exports = {"legend":"FeatureStateLegend_legend_1X4T2","checkbox":"FeatureStateLegend_checkbox_HW3pk"};